import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {AsaxElasticService, ElasticParser, ElasticParserFactory} from 'asax-elastic';

@Injectable({
  providedIn: 'root'
})
export class TypeaheadService {
  private regexParser: ElasticParser;

  constructor(private readonly asaxElasticService: AsaxElasticService,
              private readonly elasticParserFactory: ElasticParserFactory) {
    this.regexParser = this.elasticParserFactory.getElasticParser('regex');
  }

  search(term: string, index: string, keyword: string): Observable<string[]> {
    if (term === '') {
      return of([]);
    }

    return this.asaxElasticService.searchByQuery({
      index,
      body: {
        from: 0,
        size: 0,
        query: this.regexParser.parseValue(term, {property: [keyword]}),
        aggregations: {tokens: {terms: {field: keyword}}}
      }
    }).pipe(
      map(({aggregations}) => aggregations.tokens.buckets.map(({key}) => key)),
      catchError(() => [])
    );
  }
}
